import { Post } from '@/@types/post'
import { css } from '@emotion/react'
import { CloseIcon } from '@ruguoapp/jike-fe-icons'
import { ModalProps } from '../Modal/types'
import { showModal } from '../Modal/utils'
import PostCard from '../Post/PostCard'
import Comment from './Comment'
import CommentForm from './CommentForm'
import type { ReplyToComment } from './types'

export interface CommentFormModalProps extends ModalProps {
	onSubmit?: () => void
	replyToComment?: ReplyToComment | null
	replyToPost?: Post | null
}

export function showCommentFormModal(options?: Omit<CommentFormModalProps, 'isShow'>) {
	const { onSubmit, onClose = () => {}, replyToComment, replyToPost, ...rest } = options ?? {}
	const toComment = replyToComment?.to

	return showModal(
		null,
		<div
			css={css`
				display: flex;
				flex-direction: column;
				gap: 20px;
				color: var(--tint-primary);
			`}
		>
			{replyToPost && (
				<PostCard
					data={replyToPost}
					css={css`
						padding: unset;
					`}
				/>
			)}

			{toComment && (
				<Comment
					data={{
						id: toComment.id,
						targetType: toComment.targetType,
					}}
					noActions
					showThreadLine
					noSuffixTitle
				/>
			)}

			<CommentForm
				targetId={replyToPost?.id}
				replyToComment={replyToComment}
				onSubmit={async () => {
					onClose?.()
					onSubmit?.()
				}}
			/>
		</div>,
		{
			header: (
				<>
					<div
						css={css`
							display: flex;
							width: fit-content;
							cursor: pointer;
						`}
						onClick={onClose}
					>
						<CloseIcon
							css={css`
								width: 24px;
								aspect-ratio: 1;
							`}
						/>
					</div>
					<div
						css={css`
							justify-content: center;
						`}
					>
						回复
					</div>
					<div />
				</>
			),
			backdrop: 'static',
			centered: true,
			withCloseButton: false,
			fullScreen: true,
			onClose,
			...rest,
		}
	)
}
